import { Reveal } from "./primitives";
import { OF_STATS } from "./orderFlowData";

export const OrderFlowStats = () => (
  <section data-testid="of-stats" className="relative border-y border-white/[0.06] bg-[#0D0E11]">
    <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-px bg-white/[0.06] lg:grid-cols-4">
      {OF_STATS.map((s, i) => (
        <Reveal key={s.unit} delay={i * 0.08} className="bg-[#0D0E11] px-5 py-10 sm:px-6 md:px-10 md:py-12">
          <div data-testid={`of-stat-${s.unit.replace(" ", "-")}`} className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
            <span className="font-display text-3xl font-semibold tracking-[-0.03em] text-[#ECEBE4] sm:text-4xl md:text-5xl">{s.value}</span>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#7D8390]">{s.unit}</span>
          </div>
          <p className="mt-3 max-w-[260px] font-mono text-[11px] leading-relaxed text-[#7D8390] md:text-xs">{s.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
